"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserAgentContext_1 = require("./UserAgentContext");
Object.defineProperty(exports, "UserAgentContext", { enumerable: true, get: function () { return UserAgentContext_1.UserAgentContext; } });
